export default __webpack_public_path__ + "static/media/flag-cyprus.ad5b709c.svg";